import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

// 🔹 Helper to strip HTML tags and normalize whitespace
function stripHtmlTags(html = "") {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export default class AboutUs extends Component {
  state = {
    allJobs: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    noticolor: "success",
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllSubjects(this.state.page_no, this.state.per_page);
  }

  getAllSubjects = (page, limit) => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getAboutUs}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              allJobs: resp.data.data.docs,
              pagination: resp.data.data, // whole pagination object from backend
              page_no: resp.data.data.page,
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Error fetching questions",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllSubjects(1, newLimit); // reset to first page with new limit
    });
  };

  // ✅ Handle page change (from DataTable)
  handlePageChange = (newPage) => {
    this.getAllSubjects(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteAbout + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  // you might want to pass current page/per_page here
                  this.getAllSubjects(this.state.page_no, this.state.per_page);
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.message,
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getAllSubjects(this.state.page_no, this.state.per_page);
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    About Us
                  </MDTypography>
                </MDBox>
                <Grid item sm={4} px={2} align="right">
                  <Link to="/addsubject">
                    <MDButton variant="contained" size="small" color="primary">
                      Create
                    </MDButton>
                  </Link>
                </Grid>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "Youtube", accessor: "youtube" },
                        { Header: "image", accessor: "image" },
                        { Header: "action", accessor: "action" },
                      ],
                      rows: this.state.allJobs.map((job, index) => {
                        const cleanText = stripHtmlTags(job.description || "");
                        const preview =
                          cleanText.length > 250 ? cleanText.substring(0, 250) + "..." : cleanText;

                        return {
                          serial: index + 1,
                          youtube: job.youtube_id, // ✅ plain text, no HTML tags
                          image: (
                            <img
                              src={Constants.imageDomain + job.image}
                              height="100px"
                              alt="About us"
                            />
                          ),
                          action: (
                            <>
                              <div>
                                <Link
                                  to={{
                                    pathname: "/updatesubject/" + job._id,
                                    state: { data: job },
                                  }}
                                >
                                  <MDButton variant="outlined" size="small" color="success">
                                    Update
                                  </MDButton>
                                </Link>
                              </div>
                              <div style={{ marginTop: "1rem" }}>
                                <MDButton
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() => this.handleDelete(job._id)}
                                >
                                  Delete
                                </MDButton>
                              </div>
                            </>
                          ),
                        };
                      }),
                    }}
                    entriesPerPage={{ defaultValue: 20 }}
                    page_no={this.state.pagination?.page}
                    totalPages={this.state.pagination?.totalPages}
                    hasNextPage={this.state.pagination?.hasNextPage}
                    hasPrevPage={this.state.pagination?.hasPrevPage}
                    isnextPage={this.state.pagination?.nextPage}
                    prevPage={this.state.pagination?.prevPage}
                    totalDocs={this.state.pagination?.totalDocs}
                    onPageChange={this.handlePageChange}
                    onEntriesPerPageChange={this.handleEntriesPerPageChange}
                  />
                </MDBox>
                <MDSnackbar
                  color={this.state.noticolor}
                  icon="notifications"
                  title="VASA | About Us "
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                />
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
